import { render, staticRenderFns } from "./Crumb.vue?vue&type=template&id=b9084c06&"
import script from "./Crumb.vue?vue&type=script&lang=js&"
export * from "./Crumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports